export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': 'efe20517bemshea2c4699aa2e7abp163442jsn53c5748ec50f',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = 'https://wft-geo-db.p.rapidapi.com/v1/geo';

export const WEATHER_API_URL = 'https://api.openweathermap.org/data/3.0';

export const WEATHER_API_KEY = '5e49d9dcc9de492aabccb49b90e52677';